import React from "react";

const Contact = () => {
  return (
    <div className="h-screen flex justify-center items-center bg-yellow-500">
      <h1 className="text-9xl uppercase font-black text-white">egg contact</h1>
    </div>
  );
};

export default Contact;
